<template>
    <div class="form-group">
        <label for="years-control" v-if="label">Año <span class="required-check-mark" v-if="!!required">*</span></label>
        <select
            class="form-control"
            name="years-control"
            id="years-control"
            @change="({target}) => $emit('input', parseInt(target.value))"
            v-bind="$attrs" 
            v-on="$listeners"
        >
            <option value="" v-if="placeholder">Año</option>
            <option value="" v-else>-- Seleccione --</option>
            <option v-for="year in years" :key="year.id" :value="year.id" :selected="year.id === value">{{ year.name }}</option>
        </select>
        <span class="field-error" v-if="!!hasError">{{ errorMessage }}</span>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    inheritAttrs: false,
    props: {
        placeholder: {
            type: Boolean,
            default: false
        },
        label: {
            type: Boolean,
            default: true
        },
        errorMessage: {
            type: String,
            default: ''
        },
        hasError: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        value: {}
    },
    computed: {
        ...mapGetters(['years'])
    },
    created() {
        this.load('years');
    }
}
</script>